import React, { useContext, useEffect, useState } from "react";

import PageContainer from "../../components/PageGeneralContainer/PageGeneralContainer";

import request from "../../utils/request.js";
import t from "../../utils/translation.js";
import LocalizationContext from "../../utils/LocalizationContext.js";

import styles from "./MaterialStatus.module.css";

import ButtonQ from "../../components/ButtonQ/ButtonQ.js";
import ChangeMaterialStatus from "../../components/ChangeMaterialStatus/ChangeMaterialStatus.jsx";
import TreeView from "../../components/TreeView/TreeView.jsx";
import { Tab, Tabs } from "@material-ui/core";
import MaterialStockForm from "../../components/MaterialStockForm/MaterialStockForm.jsx";

const MaterialStatus = () => {
  const [selectedTab, setSelectedTab] = useState("first");

  return (
    <div className={styles.pageContainer}>
      <div className={styles.tabButtonsContainer}>
         <button 
          className={`${styles.tabButton} ${selectedTab === "first" ? styles.active : ""}`}
          onClick={() => setSelectedTab("first")}
        >
          {t("BlankEntry163") || "Stock Control"}
        </button>
        <button 
          className={`${styles.tabButton} ${selectedTab === "second" ? styles.active : ""}`}
          onClick={() => setSelectedTab("second")}
        >
          {t("BlankEntry164") || "Status"}
        </button>
        <button 
          className={`${styles.tabButton} ${selectedTab === "third" ? styles.active : ""}`}
          onClick={() => setSelectedTab("third")}
        >
           {t("BlankEntry165") || "Status change"}
        </button>
      </div>
      
      <div className={styles.page}>
        <div className={styles.componentContainer}>
          {selectedTab === "first" && <MaterialStockForm />}
           {selectedTab === "second" &&  <TreeView />}
          {selectedTab === "third" &&  <ChangeMaterialStatus />}
        </div>
      </div>
    </div>
  );
};


export default MaterialStatus;
